export default __webpack_public_path__ + "assets/icons/Nezha2.73a7369c.ico";